"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RelatedArticlesCard = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ContentstackImg = require("../../../ContentstackImg");
var _TimeAgo = _interopRequireDefault(require("../../../TimeAgo"));
var _isLinkExternal = _interopRequireDefault(require("../../utils/is-link-external"));
var _styles = require("./styles");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
// Explicit export is unwrapped with 'styled'
var RelatedArticlesCard = function RelatedArticlesCard(_ref) {
  var item = _ref.item,
    className = _ref.className,
    index = _ref.index,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? "" : _ref$testId;
  // Default to "today" if an invalid or empty publishedAt date is passed.
  // Note that this means that the published date element will always show
  var publishedAtDate = new Date(item.publishedAt) || new Date();
  return /*#__PURE__*/_react.default.createElement(_styles.BaseRelatedArticlesCard, {
    className: "".concat(className, " related-articles-card"),
    "data-testid": testId
  }, /*#__PURE__*/_react.default.createElement(_styles.BaseRelatedArticleLinkWrapper, {
    href: item.action.url,
    target: (0, _isLinkExternal.default)(item.action) ? "_blank" : "_self",
    "data-testid": "".concat(testId, ":link")
  }, /*#__PURE__*/_react.default.createElement(_styles.WrapperInner, null, /*#__PURE__*/_react.default.createElement(_styles.BaseRelatedArticlesImageWrapper, null, /*#__PURE__*/_react.default.createElement(_styles.BaseRelatedArticleImageInner, {
    "data-testid": "".concat(testId, ":image")
  }, /*#__PURE__*/_react.default.createElement(_ContentstackImg.ContentstackImg, {
    image: item.image,
    optimized: true,
    style: {
      position: "absolute",
      width: "100%",
      height: "100%",
      objectFit: "cover",
      objectPosition: "center"
    }
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "related-article-info"
  }, index && /*#__PURE__*/_react.default.createElement("div", {
    className: "related-article-index"
  }, index), item.category && /*#__PURE__*/_react.default.createElement("div", {
    className: "related-article-category",
    "data-testid": "".concat(testId, ":category")
  }, item.category), /*#__PURE__*/_react.default.createElement("div", {
    className: "related-article-title",
    "data-testid": "".concat(testId, ":title")
  }, item.title), /*#__PURE__*/_react.default.createElement("div", {
    className: "related-article-excerpt",
    "data-testid": "".concat(testId, ":description")
  }, item.description), item.author && /*#__PURE__*/_react.default.createElement("div", {
    className: "related-article-author",
    "data-testid": "".concat(testId, ":author")
  }, item.author), /*#__PURE__*/_react.default.createElement("div", {
    className: "related-article-published"
  }, /*#__PURE__*/_react.default.createElement(_TimeAgo.default, {
    dateTime: publishedAtDate,
    language: item.locale,
    testId: "".concat(testId, ":time")
  }))))));
};

// default export is wrapped with styled
exports.RelatedArticlesCard = RelatedArticlesCard;
var _default = (0, _styledComponents.default)(RelatedArticlesCard).withConfig({
  displayName: "RelatedArticlesCard",
  componentId: "sc-17v1ff0-0"
})([""]);
exports.default = _default;